<div class="rd-widget rd-widget-no-height-restriction ownership-and-transaction-widget-container widget-{{widgetConfig.widgetId}}" *ngIf="widgetData">
  <!--last sale-->
  <table class="widget-large" aria-hidden="true">
    <thead>
      <tr>
        <ng-container *ngIf="editMode">
          <th scope="col" class="widget-grid-column">
            <span class="k-icon k-i-minus" (click)="deleteCurrentRow(rowsLastSale, 'sale')"></span>
            <span class="k-icon k-i-plus" (click)="addRow(rowsLastSale, 'sale')" *ngIf="sectionHasAvailableFields('ownershipAndTransactionHistory-lastsale')"></span>
            <span class="k-icon k-i-arrow-up" (click)="moveCurrentRowUp(rowsLastSale, 'sale')"></span>
            <span class="k-icon k-i-arrow-down" (click)="moveCurrentRowDown(rowsLastSale, 'sale')"></span>
          </th>
        </ng-container>
        <th scope="col" colspan="3" class="widget-grid-column">
          <widget-value [align]="'left'" [color]="'white'" [bold]="true">{{'ownershipAndTransactionHistory.labelTitle' | rdTranslate}}</widget-value>
        </th>
        <ng-container *ngIf="!editMode">
          <th scope="col" class="widget-grid-column">
            &nbsp;
          </th>
        </ng-container>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <rd-textandlist-section [widget]="this" [widgetId]="this.widgetConfig.widgetId" [page]="page" [selectedTag]="hashTag" [sectionName]="textAndListSectionNameLastSale" [disableCustomLabels]="disableCustomLabels" [reflists]="reflists" [topicReflist]="'ref_l3_country_specifics_last_sale'"
                              [editMode]="editMode" [rows]="rowsLastSale" [leftColspan]="6" [rightColspan]="6"
                              [data]="widgetData" [alternatingColorScheme]="true" [currency]="currency"
                              [unitOfArea]="unitOfArea" [addRow]="addRowLastSale$" [deleteCurrentRow]="deleteCurrentRowLastSale$"
                              [moveCurrentRowUp]="moveCurrentRowUpLastSale$" [moveCurrentRowDown]="moveCurrentRowDownLastSale$"
                              (dataChanged)="onDataChanged()"
                              (sectionRowsCountChanged)="sectionRowsCountChanged($event)">
      </rd-textandlist-section>
    </tbody>
  </table>
  <div class="space-part">&nbsp;</div>
</div>
